import SignUp from "../templates/SignUp"

const SignUpPage  = () => {
    return (
        
        <div className = "full-container" >
            <SignUp/>
        </div>
    )
}

export default SignUpPage